"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["small", "xsmallIconOnly", "href", "newWindow", "loadingSrText", "ssrIcon", "iconOnly", "prefix", "htmlType", "disabled", "className", "onClick", "text", "type", "expanding", "loading", "iconPosition", "fluid", "inverseTheme", "children", "expandedOnTouchDevice"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var inverseTypes = ['primary', 'emphasised', 'secondary', 'tertiary'];

var Button = function Button(_ref) {
  var small = _ref.small,
      xsmallIconOnly = _ref.xsmallIconOnly,
      href = _ref.href,
      newWindow = _ref.newWindow,
      loadingSrText = _ref.loadingSrText,
      ssrIcon = _ref.ssrIcon,
      iconOnly = _ref.iconOnly,
      prefix = _ref.prefix,
      htmlType = _ref.htmlType,
      disabled = _ref.disabled,
      className = _ref.className,
      onClick = _ref.onClick,
      text = _ref.text,
      type = _ref.type,
      expanding = _ref.expanding,
      loading = _ref.loading,
      iconPosition = _ref.iconPosition,
      fluid = _ref.fluid,
      inverseTheme = _ref.inverseTheme,
      children = _ref.children,
      expandedOnTouchDevice = _ref.expandedOnTouchDevice,
      others = _objectWithoutProperties(_ref, _excluded);

  function onKeyUpHandler(e) {
    if (e.key !== 'Spacebar' && e.key !== ' ') {
      return true;
    }

    e.target.click();
  }

  var btnType = type ? type : 'secondary';

  if (iconOnly && ssrIcon) {
    btnType = "icon-".concat(btnType);
  }

  if (inverseTheme && inverseTypes.indexOf(type) > -1) {
    btnType = "".concat(btnType, "-inverse");
  }

  var innerClasses = (0, _classnames.default)("".concat(prefix, "btn__inner"));
  var classes = (0, _classnames.default)("".concat(prefix, "btn"), loading && "".concat(prefix, "btn--loading"), small && "".concat(prefix, "btn--small"), iconOnly && xsmallIconOnly && "".concat(prefix, "btn--xsmall"), !iconOnly && ssrIcon && iconPosition && "".concat(prefix).concat(iconPosition, "-icon"), type && "".concat(prefix, "btn--").concat(btnType), fluid && !iconOnly && "".concat(prefix, "btn--fluid"), expanding && "".concat(prefix, "btn--expanding"), expanding && expandedOnTouchDevice && "".concat(prefix, "btn--touch-device-expanded"), className);
  var iconTag;
  var iconClass = "".concat(prefix, "btn__icon");

  if (ssrIcon) {
    iconTag = _react.default.createElement(_ssrIcon.default, {
      className: iconClass,
      prefix: prefix,
      paths: ssrIcon
    });
  }

  var ButtonTag = href ? 'a' : 'button';
  var onKeyUp = ButtonTag === 'a' ? onKeyUpHandler : null;
  var role = href ? 'button' : null;

  var linkProps = _objectSpread(_objectSpread({}, href && {
    href: href
  }), newWindow && {
    target: '_blank'
  });

  var button = _react.default.createElement(ButtonTag, _extends({
    type: !href ? htmlType : null,
    role: role,
    disabled: disabled,
    className: classes,
    onClick: onClick,
    onKeyUp: onKeyUp
  }, linkProps, others), _react.default.createElement("span", {
    className: innerClasses
  }, iconTag && iconTag, text && _react.default.createElement("span", {
    className: "".concat(prefix, "btn__label")
  }, text), children && children, loading && _react.default.createElement("span", {
    className: "".concat(prefix, "btn__loader")
  }, loadingSrText)));

  return button;
};

Button.defaultProps = {
  text: '',
  disabled: false,
  htmlType: 'button',
  type: 'secondary',
  prefix: '',
  iconOnly: false,
  iconPosition: 'leading',
  loadingSrText: 'Loading…'
};
var _default = Button;
exports.default = _default;